import PaymentUserAddress, {
  PaymentUserAddressProps,
  PAYMENT_USER_ADDRESS_FIELDS,
} from './PaymentUserAddress';

export type { PaymentUserAddressProps };
export { PaymentUserAddress, PAYMENT_USER_ADDRESS_FIELDS };
export default PaymentUserAddress;
